import React, { useState, useEffect } from "react";
import ReceivedRequest from "./cards/ReceivedRequest";
import "./InterviewerRequest.css";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Button } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import DatePicker from "react-date-picker";
import Snackbar from "@mui/material/Snackbar";
import Typography from "@mui/material/Typography";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Slide from "@mui/material/Slide";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import axios from "axios";
import { Helmet } from "react-helmet";
import { setDate } from "date-fns/esm";
import Accordian from "./cards/Accordian";
import Navbar from "./Navbar";
import NavbarStudents from "../Dashboard/Navbarlogedin";
import NavbarProfessionals from "../Interviewer/NavbarInterviewer";
import Footer from "../Home/Footer";

const InterviewerRequest = () => {
  const user = JSON.parse(localStorage.getItem("isIAuthenticated"));
  const [cards, setCards] = React.useState();
  useEffect(() => {
    setTimeout(() => window.scrollTo(0, 0), 100);
  }, []);
  function TransitionRight(props) {
    setDate(null);
    return <Slide {...props} direction="right" />;
  }
  const [date, setDate] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [transition, setTransition] = React.useState(undefined);
  const handleClick = (Transition) => () => {
    setTransition(() => Transition);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    async function fetchData() {
      const req = await axios.get(`${process.env.REACT_APP_SERVER_URL}/api/get`);
      setCards(req.data);
      // console.log(req.data);
    }
    fetchData();
  }, []);

  // Stacking of Cards according to slots
  var card = [
    {
      name: "Sam Smith",
      desg: "YouTube",
      slot: "[5:00 PM - 5:30 PM] 20 June 2022",
      id: "#acb789a1",
      status: "accepted",
      payment: false,
    },
    {
      name: "Sam Smith 1",
      desg: "YouTube",
      slot: "[5:00 PM - 5:30 PM] 20 June 2022",
      id: "#acb789a1",
      status: "accepted",
      payment: false,
    },
    {
      name: "Sam Smith 2",
      desg: "YouTube",
      slot: "[5:00 PM - 5:30 PM] 20 June 2022",
      id: "#acb789a1",
      status: "accepted",
      payment: false,
    },
    {
      name: "Sam Smith 3",
      desg: "YouTube",
      slot: "[5:00 PM - 5:30 PM] 20 June 2022",
      id: "#acb789a1",
      status: "accepted",
      payment: false,
    },
    // {
    //   name: "Sam Smith 4",
    //   desg: "YouTube",
    //   slot: "[5:00 PM - 5:30 PM] 20 June 2022",
    //   id: "#acb789a1",
    //   status: "accepted",
    //   payment: false,
    // },
    {
      name: "Tim cook",
      desg: "CEO, Apple",
      slot: "[6:00 PM - 6:30 PM] 20 June 2022",
      id: "#acb789a1",
      status: "accepted",
      payment: false,
    },
    // {
    //   name: "Bill Gates",
    //   desg: "Founder, Microsoft",
    //   slot: "[5:00 PM - 5:30 PM] 20 June 2022",
    //   id: "#acb789a1",
    //   status: "accepted",
    //   payment: false,
    // },
    // {
    //   name: "Steve Jobs",
    //   desg: "Co-founder, former CEO, Apple",
    //   slot: "[7:00 PM - 7:30 PM] 20 June 2022",
    //   id: "#acb789a1",
    //   status: "accepted",
    //   payment: false,
    // },
    {
      name: "Sunder Pichai",
      desg: "CEO, Alphabet",
      slot: "[5:00 PM - 5:30 PM] 20 June 2022",
      id: "#acb789a1",
      status: "accepted",
      payment: false,
    },
    {
      name: "Ratan Tata",
      desg: "Chairman of Tata Groups",
      slot: "[10:00 PM - 10:30 PM] 20 June 2022",
      id: "#acb789a1",
      status: "accepted",
      payment: false,
    },
    {
      name: "John Doe",
      desg: "SDE II, Walmart, USA",
      slot: "[10:00 PM - 10:30 PM] 20 June 2022",
      id: "#acb789a1",
      status: "accepted",
      payment: false,
    },
  ];

  const [stack, setStack] = useState([]); // Stacked Database
  // Stacking function to stack all the same slot cards from actual database
  const stacking = () => {
    let localCards = [...stack];
    card.map((item) => {
      if (localCards.length === 0) {
        localCards.push({ slot: item.slot, array: [item] });
        return;
      }
      let check = false;
      localCards.map((cItem, index) => {
        if (cItem.slot === item.slot) {
          localCards[index].array.push(item);
          check = true;
        }
      });
      if (!check) {
        localCards.push({ slot: item.slot, array: [item] });
      }
    });
    setStack(localCards);
  };
  // Removing the card on Accepting or Declining the request
  const remove = (first, second) => {
    let localCards = [...stack];
    localCards[first].array.splice(second, 1);
    setStack(localCards);
  };
  const removeEntire = (first) => {
    let localCards = [...stack];
    localCards.splice(first, 1);
    setStack(localCards);
  };
  useEffect(() => {
    stacking();
  }, []);
  useEffect(() => {
    console.log(stack);
  }, [stack]);

  // Switching the next card
  const switchNextCard = (index) => {
    var list = [...stack];
    const first = list[index].array[0];
    list[index].array.splice(0, 1);
    list[index].array.push(first);
    setStack(list);
  };
  // Switching the previous card
  const switchPrevCard = (index) => {
    var list = [...stack];
    const last = list[index].array[list[index].array.length - 1];
    console.log(last);
    list[index].array.pop();
    list[index].array.splice(0, 0, last);
    setStack(list);
  };
  return (
    <>
      {!user?.role ? <Navbar /> : null}
      {user?.role === "Student" ? <NavbarStudents /> : null}
      {user?.role === "Interviewer" ? <NavbarProfessionals /> : null}
      <Helmet>
        <title>Interwiu | Recieved Request</title>
        <meta name="description" content="Helmet application" />
      </Helmet>
      <div className="sent-request interviews">
        <div className="interviews-container">
          <div className="flex justify-center items-center my-4 mx-4" id="head">
            <h2 className="interview-head text-2xl font-medium">
              Received Requests (12)
            </h2>
          </div>
          <div className="relative interviews-cont">
            <div className="flex justify-between mx-8">
              <div>
                Showing the results for{" "}
                {date ? date.toDateString() : "all days"}
              </div>
              <div className="flex gap-2">
                <label htmlFor="date">Filter by Date: </label>
                {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    label="Choose Date"
                    value={date}
                    onChange={(newValue) => {
                      setDate(newValue);
                    }}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider> */}
                <DatePicker
                  onChange={(newValue) => {
                    setDate(newValue);
                  }}
                  value={date}
                />
                {/* <div
                  className="text-2xl cursor-pointer hover:text-red-500"
                  onClick={handleClick(TransitionRight)}
                >
                  <i className="fa-solid fa-trash-can"></i>
                </div>
                <Snackbar
                  open={open}
                  onClose={handleClose}
                  TransitionComponent={transition}
                  message="Date Cleared"
                  key={transition ? transition.name : ""}
                /> */}
              </div>
            </div>
            <div className="w-4/5 px-5 mx-auto">
              {stack?.map((item, index) => {
                if (item.length === 0) {
                  return;
                }
                return (
                  <Accordian
                    array={item.array}
                    index={index}
                    stack={stack}
                    setStack={setStack}
                    remove={remove}
                    removeEntire={removeEntire}
                  />
                );
              })}
              {cards?.map((result) => (
                <>
                  <ReceivedRequest
                    name={result.fromname}
                    desg={result.profile}
                    slot={result.slot}
                    id={result._id}
                    status={result.status}
                  />
                </>
              ))}
              <ReceivedRequest
                name="John Doe"
                desg="ML Engineer, YouTube, Google"
                slot="[na]"
                id="#7a9fd8"
                status="pending"
              />
            </div>
            <div className="interviews-else">
              <p>
                Lorem ipsum dolor sit, amet consectetur adipisicing elit. Cumque
                sapiente architecto, deserunt obcaecati illo soluta alias at
                dolore, libero quia necessitatibus animi autem ab! Ipsa
                veritatis perferendis magni? Ad, facere!
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default InterviewerRequest;
